import { waveV3 } from '@/api/config/index.js';

export async function getUserLoyaltySummary() {
  try {
    const response = await waveV3.get('/loyalty/users/me/summary');
    const data = response.data;
    return { data };
  } catch (error) {
    return { error: error?.response?.data };
  }
}

export async function getUserLoyaltyTransactions({ pageNumber, pageSize }) {
  try {
    const response = waveV3.get('/loyalty/users/me/transactions', {
      params: { pageSize, pageNumber },
    });
    return response;
  } catch (error) {
    return { error: error?.response?.data };
  }
}
